// 2026-06-20 (user request "REKONSILIASI ANGKA KEUANGAN DASHBOARD") — tooltip
// rumus + label ruang lingkup. Sumber angka: GET /api/dashboard/finance-reconciliation
// (SATU endpoint kanonik utk Dashboard, Laporan Keuangan, dan Kas & Bank).
export const FINRECON_TOOLTIPS = {
  penerimaan_invoice:
    "Penerimaan Invoice = Σ mutasi masuk bank yang berasal dari invoice universe (project non-TEST, non-internal, bukan klaim retensi). Sumber: mutasi rekening perusahaan. Kolom klasifikasi: invoice_counted.",
  pemasukan_lainnya:
    "Pemasukan Lainnya = Σ mutasi masuk selain invoice universe — pengembalian petty cash, invoice TEST/internal/retensi. TIDAK dicampur ke Penerimaan Invoice.",
  total_mutasi_masuk:
    "Total Mutasi Masuk = Penerimaan Invoice + Pemasukan Lainnya. Hanya mutasi dalam periode filter.",
  pengeluaran:
    "Pengeluaran = Σ mutasi keluar bank periode berjalan (biaya proyek + transfer petty cash).",
  saldo_bersih_periode:
    "Saldo Bersih Periode = Total Mutasi Masuk − Pengeluaran. TIDAK memuat saldo awal.",
  invoice_belum_diterima:
    "Nilai Invoice Belum Diterima = Σ overdue_receivable seluruh project (snapshot per hari ini, bukan periode).",
  retensi_belum_jt:
    "Retensi Belum Jatuh Tempo = Σ retention_not_yet_due seluruh project (snapshot per hari ini).",
  saldo_awal_gabungan:
    "Saldo Awal Rekening (di luar mutasi periode) = Σ opening_balance seluruh rekening perusahaan. TIDAK dicampur ke penerimaan.",
  saldo_akhir_gabungan:
    "Saldo Akhir Rekening = Saldo Awal + Total Mutasi Masuk − Pengeluaran.",
};

export function formatPeriodLabel(period) {
  if (!period) return "";
  const from = period.date_from;
  const to = period.date_to;
  if (!from && !to) return `Per tanggal ${period.as_of || "hari ini"} · semua periode`;
  if (from && to) return `Periode ${from} → ${to}`;
  if (from) return `Sejak ${from}`;
  return `Hingga ${to}`;
}
